<template>
  <div id="app">
    <router-view></router-view>
    <loading
      class="loading-full-screen fixed"
      v-if="isLoading"
    ></loading>
    <error-alert/>
  </div>
</template>

<script>
import Loading from "./Loading.vue";
import ErrorAlert from "./ErrorAlert.vue";
import { mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
      section: "Head"
    };
  },
  components: {
    Loading,
    ErrorAlert
  },
  computed: {
    ...mapState(["isLoading"])
  },
  methods: {
    logout() {
      this.$store.commit("SET_USER", null);
      this.$store.commit("SET_TOKEN", null);

      if (window.localStorage) {
        window.localStorage.setItem("user", null);
        window.localStorage.setItem("token", null);
      }

      this.$router.push("/login");
    }
  }
};
</script>

<style>
.loading-full-screen {
  z-index: 999999999999;
}
</style>



// WEBPACK FOOTER //
// App.vue?9ce9667a